import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/job-market/salary-calculator/page.tsx");
